import React, { useState } from 'react';
import '../styles/Page.css';

function Page() {
    return (
        <div className='page'>
            <div>
                <img src="img/VF3.jpg" />
                <img src="img/VF4.jpg" />
                <img src="img/VF5.jpg" />
                <img src="img/VF1.jpg" />
                <img src="img/VF2.jpg" />
               
                <p style={{ textAlign: 'right' }}><i>Vanished Fantasy</i>, 2021. Multimedia Performance, Senggi Studio, Seoul.</p>
                <p><i>Vanished Fantasy</i> depicts a future, post mankind, where machine and technology blend into nature. An advanced biotech environment, symbiotically linked to the nature world.</p>
                <br />
            </div>
        </div>

    )
}

export default Page;